export function hexToRgba(hex: any, opacity: any) {
    // Nettoyer le # si présent
    hex = hex.replace('#', '');
  
    // Gestion des formats courts (#eee) ou longs (#eeeeee)
    if (hex.length === 3) {
      hex = hex.split('').map((c: any) => c + c).join('');
    }
  
    // Extraire les valeurs RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
  
    // Retourner la couleur en rgba
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }